const PortfolioContent = () => {
    return (
        <>
            <h4>
                Local therapy trials become a bigger part of the BCT portfolio
            </h4>
            <p>
                Local therapy trials become a bigger part of the Breast Cancer Trials portfolio, such as PROSPECT and POSNOC, that are all looking at de-escalation of local therapy for selected patients. 
            </p>
        </>
    );
}

export default PortfolioContent;